import React from "react";
import { Textarea } from "../../../ui/textarea";
import { Switch } from "../../../ui/switch";

const NotesDetail = ({ notes, onNotes, showHistory, useHistory, onUseHistory }) => (
  <>
    <div className="space-y-2">
      <Textarea
        id="gen-session-notes"
        value={notes || ""}
        onChange={(e) => onNotes(e.target.value)}
        placeholder="e.g. Lower back is stiff, dumbbells only today, heavy upper body..."
        rows={4}
        className="w-full resize-none bg-background/50 text-sm"
      />
      <p className="text-xs leading-snug text-muted-foreground">
        For today only. Injuries that last belong in your profile.
      </p>
    </div>
    {showHistory && (
      <div className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background/40 p-3">
        <div className="min-w-0">
          <label htmlFor="gen-history-guidance" className="text-sm font-semibold text-foreground">
            Use my recent training
          </label>
          <p className="text-xs leading-snug text-muted-foreground">
            Vary today's session around what you trained lately.
          </p>
        </div>
        <Switch id="gen-history-guidance" checked={useHistory} onCheckedChange={onUseHistory} />
      </div>
    )}
  </>
);

export default NotesDetail;
